import React from 'react';
import { withRouter } from 'react-router-dom';
import PropTypes from 'prop-types';
import styled from 'styled-components';

import RevisionHistory, {
  OBJECT_TYPES,
} from '../../components/revisionHistory';

const OwnerRevisionHistory = ({ ownerID }) => (
  <OwnerRevisionHistory.Wrapper>
    <OwnerRevisionHistory.Container>
      <RevisionHistory objectType={OBJECT_TYPES.OWNER} objectId={ownerID} />
    </OwnerRevisionHistory.Container>
  </OwnerRevisionHistory.Wrapper>
);

OwnerRevisionHistory.propTypes = {
  ownerID: PropTypes.number,
};

OwnerRevisionHistory.Wrapper = styled.div`
  background-color: transparent;
`;

OwnerRevisionHistory.Container = styled.div`
  background-color: white;
  padding: 10px;
`;

export default withRouter(OwnerRevisionHistory);
